__turbopack_context__.v({
  "background": "BlockFeaturedArticle-module-scss-module__g9g8Qa__background",
  "content": "BlockFeaturedArticle-module-scss-module__g9g8Qa__content",
  "cta": "BlockFeaturedArticle-module-scss-module__g9g8Qa__cta",
  "eyebrow": "BlockFeaturedArticle-module-scss-module__g9g8Qa__eyebrow",
  "flushBottom": "BlockFeaturedArticle-module-scss-module__g9g8Qa__flushBottom",
  "flushTop": "BlockFeaturedArticle-module-scss-module__g9g8Qa__flushTop",
  "foreground": "BlockFeaturedArticle-module-scss-module__g9g8Qa__foreground",
  "headline": "BlockFeaturedArticle-module-scss-module__g9g8Qa__headline",
  "image": "BlockFeaturedArticle-module-scss-module__g9g8Qa__image",
  "inner": "BlockFeaturedArticle-module-scss-module__g9g8Qa__inner",
  "line": "BlockFeaturedArticle-module-scss-module__g9g8Qa__line",
  "root": "BlockFeaturedArticle-module-scss-module__g9g8Qa__root",
});
